module.exports = __webpack_public_path__ + "static/stadt-wien-75fd3ac46a5b093a43c7e4d45a1f64fe.png";